import React from 'react';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-white py-12 px-4 sm:py-16 sm:px-6 md:py-28" data-id="element-184">
      <div className="max-w-3xl mx-auto" data-id="element-185">
        {/* The Pain - Condensed */}
        <div className="mb-12 text-center" data-id="element-186">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-[#4C1D95] mb-6" data-id="element-187">
            El problema no es el dolor. Es la incertidumbre.
          </h2>

          <p className="text-lg text-[#444444] mb-8 max-w-2xl mx-auto" data-id="element-188">
            La lesión te quita tu rutina, tu energía y tu identidad. Y sin un
            plan claro, caes en el ciclo de siempre:
          </p>
        </div>

        {/* The Cycle - Visual */}
        <div className="text-center mb-12" data-id="element-189">
          <div className="inline-flex flex-col items-center justify-center gap-3 p-5 sm:p-6 bg-[#4C1D95] text-white rounded-xl shadow-lg w-full sm:w-auto sm:flex-row sm:gap-6 md:gap-8" data-id="element-190">
            <span className="font-bold text-lg sm:text-xl" data-id="element-191">Mejoro</span>
            <span className="hidden sm:block" data-id="element-192">→</span>
            <span className="block sm:hidden text-purple-300" data-id="element-193">↓</span>
            <span className="font-bold text-lg sm:text-xl text-[#A3E635]" data-id="element-194">
              Me confío
            </span>
            <span className="hidden sm:block" data-id="element-195">→</span>
            <span className="block sm:hidden text-purple-300" data-id="element-196">↓</span>
            <span className="font-bold text-lg sm:text-xl opacity-80" data-id="element-197">
              Recaigo
            </span>
          </div>
        </div>

        {/* The Real Problem - Condensed Callout */}
        <div className="bg-[#F5F0E6] p-6 sm:p-8 rounded-2xl border border-[#E8E3D9] shadow-sm flex flex-col sm:flex-row items-start gap-4" data-id="element-198">
          <AlertCircle className="w-8 h-8 text-[#7C3AED] flex-shrink-0" data-id="element-199" />
          <div data-id="element-200">
            <h3 className="text-xl font-bold text-[#4C1D95] mb-2" data-id="element-201">
              Necesitas criterio, no esperanza.
            </h3>
            <p className="text-[#555555] mb-4" data-id="element-202">
              Dejas de preguntar "¿puedo entrenar?" y empiezas a saber cuánto,
              cómo y hasta dónde.
            </p>
            <p className="font-serif italic text-[#4C1D95] font-medium" data-id="element-203">
              Este ebook existe para devolverte el control sin venderte
              fantasía.
            </p>
          </div>
        </div>
      </div>
    </section>;
}